/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllerResponse_DatasetAttributes_ } from '../models/ControllerResponse_DatasetAttributes_';
import type { ControllerResponse_DatasetAttributes_Array_ } from '../models/ControllerResponse_DatasetAttributes_Array_';
import type { DatasetPayload } from '../models/DatasetPayload';
import type { Omit_DatasetAttributes_id_or_created_on_or_modified_on_or_deleted_on_or_next_execution_or_user_id_or_last_execution_ } from '../models/Omit_DatasetAttributes_id_or_created_on_or_modified_on_or_deleted_on_or_next_execution_or_user_id_or_last_execution_';
import type { Omit_DatasetAttributes_id_or_created_on_or_modified_on_or_deleted_on_or_user_id_or_next_execution_or_last_execution_ } from '../models/Omit_DatasetAttributes_id_or_created_on_or_modified_on_or_deleted_on_or_user_id_or_next_execution_or_last_execution_';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DatasetService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @returns ControllerResponse_DatasetAttributes_ Ok
     * @throws ApiError
     */
    public create(
        requestBody: Omit_DatasetAttributes_id_or_created_on_or_modified_on_or_deleted_on_or_user_id_or_next_execution_or_last_execution_,
    ): CancelablePromise<ControllerResponse_DatasetAttributes_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/dataset',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ControllerResponse_DatasetAttributes_Array_ Ok
     * @throws ApiError
     */
    public list(): CancelablePromise<ControllerResponse_DatasetAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/dataset/list',
        });
    }
    /**
     * @param id
     * @returns ControllerResponse_DatasetAttributes_ Ok
     * @throws ApiError
     */
    public get(
        id: number,
    ): CancelablePromise<ControllerResponse_DatasetAttributes_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/dataset/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns ControllerResponse_DatasetAttributes_ Ok
     * @throws ApiError
     */
    public update(
        id: number,
        requestBody: Omit_DatasetAttributes_id_or_created_on_or_modified_on_or_deleted_on_or_next_execution_or_user_id_or_last_execution_,
    ): CancelablePromise<ControllerResponse_DatasetAttributes_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/dataset/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns ControllerResponse_DatasetAttributes_ Ok
     * @throws ApiError
     */
    public deleteDataset(
        id: number,
    ): CancelablePromise<ControllerResponse_DatasetAttributes_> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/dataset/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any Ok
     * @throws ApiError
     */
    public previewDataset(
        requestBody: DatasetPayload,
    ): CancelablePromise<Array<Array<(string | number | boolean) | null>>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/dataset/export/preview',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public sendEmail(
        requestBody: {
            format: 'csv' | 'jsonl';
            name: string;
            emails?: Array<string>;
            dataset: DatasetPayload;
        },
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/dataset/send_email',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any Ok
     * @throws ApiError
     */
    public generateReport(
        requestBody: {
            query: string;
        },
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/dataset/report',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
